angular.module('pitch.app')
.controller('SiteMenuCtrl', function($scope, Site, SiteContext, $state) {
    "use strict";

    Site.query({}, function(r) {
        $scope.sites = r;
    });

    $scope.selectSite = function(site) {
        Site.get({
            id: site.id
        }, function(r) {
            SiteContext.set(r);
            $state.go($state.current, {}, {reload: true});
        });
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/SiteMenu.js